// ─────────────────────────────────────────────
//  defaults.js — Valores por defecto de la app
// ─────────────────────────────────────────────

export const DEFAULTS = {
	theme: 'dark',
	rememberLastTab: true,
	defaultSection: 'tips',
	defaultTip: 15,
	defaultPct: 16,
	defaultPctMode: 'discount',
	defaultRefGrams: 250,
};

export const CALC_TAB_IDS = ['tips', 'porcentajes', 'comparar', 'peso', 'inversion'];

export const SECTION_OPTIONS = [
	{ id: 'tips',        label: 'Propina' },
	{ id: 'porcentajes', label: 'Porcentaje' },
	{ id: 'comparar',    label: 'Comparar' },
	{ id: 'peso',        label: 'Peso' },
	{ id: 'inversion',   label: 'Inversión' },
];

export const TIP_OPTIONS = [10, 15, 20, 40, 50];

export const PCT_OPTIONS = [5, 10, 16, 20, 25, 50];

export const PCT_MODE_OPTIONS = [
	{ id: 'discount', label: 'Descontar' },
	{ id: 'add',      label: 'Agregar' },
];

export const REF_OPTIONS = [
	{ id: '100g',    grams: 100,  label: '100 g' },
	{ id: 'quarter', grams: 250,  label: '1/4 kg' },
	{ id: 'half',    grams: 500,  label: '1/2 kg' },
	{ id: '1kg',     grams: 1000, label: '1 kg' },
	{ id: '2kg',     grams: 2000, label: '2 kg' },
];

export const THEME_OPTIONS = [
	{ id: 'dark',  label: 'Oscuro' },
	{ id: 'light', label: 'Claro' },
];
